"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedFilter = void 0;
var AdvancedFilter = /** @class */ (function () {
    function AdvancedFilter() {
    }
    return AdvancedFilter;
}());
exports.AdvancedFilter = AdvancedFilter;
//# sourceMappingURL=AdvancedFilter.js.map